
import { initializeApp, getApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { getFirestore, Firestore } from "firebase/firestore";
import { getStorage, FirebaseStorage } from "firebase/storage";

/**
 * PASTE YOUR CONFIG HERE
 * You are on the right screen! After you click "Register app",
 * copy the values from the `firebaseConfig` object in the console into here.
 */
const firebaseConfig = {
  apiKey: "YOUR_API_KEY",
  authDomain: "your-project-id.firebaseapp.com",
  projectId: "your-project-id",
  storageBucket: "your-project-id.appspot.com",
  messagingSenderId: "YOUR_SENDER_ID",
  appId: "YOUR_APP_ID"
};

// Check if the user has actually configured Firebase
export const IS_MOCK_MODE = firebaseConfig.apiKey === "YOUR_API_KEY" || firebaseConfig.projectId.includes("your-project-id");

let app: FirebaseApp | null = null;
if (!IS_MOCK_MODE) {
  if (!getApps().length) {
    app = initializeApp(firebaseConfig);
  } else {
    app = getApp();
  }
}

/**
 * Defensive Service Initialization
 * Prevents "Component not registered" errors from breaking the app module load.
 */
function safeInit<T>(initFn: (app: FirebaseApp) => T): T | null {
  try {
    if (!app) return null;
    return initFn(app);
  } catch (e) {
    if (!IS_MOCK_MODE) console.error("Firebase Service Init Failed:", e);
    return null;
  }
}

export const auth = safeInit(getAuth) as Auth;
export const db = safeInit(getFirestore) as Firestore;
export const storage = safeInit(getStorage) as FirebaseStorage;
